import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/create/license.create.mutation.gql"
import type {
  LicenseCreateMutation,
  LicenseCreateMutationVariables,
} from "@/v2-backoffice-client/license/create/__types__/license.create.mutation"

type Options = MutationHookOptions<
  LicenseCreateMutation,
  LicenseCreateMutationVariables
>

export function useLicenseCreateMutation(options?: Options) {
  return useMutation<LicenseCreateMutation, LicenseCreateMutationVariables>(
    mutation,
    options,
  )
}
